import { render, staticRenderFns } from "./FormRFQ2Create.vue?vue&type=template&id=a0c461da&"
import script from "./FormRFQ2Create.vue?vue&type=script&lang=js&"
export * from "./FormRFQ2Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports